import { saveAs } from 'file-saver';
import { getJwtToken, refreshJwtToken } from 'app/store/auth';
import { mapResponseStatus } from 'app/lib/error';

async function getFreshJwtToken() {
    await new Promise((onSuccess, onError) => {
        refreshJwtToken({ onSuccess, onError });
    });
    return getJwtToken();
}

type TDownloadArguments = {
    url: string;
    preparedDownloadFilename: string;
    onDownloadSucceeded: () => void;
    onDownloadFailure: (error: { _type: string; message?: string; code?: string }) => void;
};
async function download({
    url,
    preparedDownloadFilename,
    onDownloadSucceeded,
    onDownloadFailure
}: TDownloadArguments) {
    try {
        const jwt = await getFreshJwtToken();
        const request = new Request(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${jwt}`
            }
        });

        const response = await fetch(request);
        if (!response.ok) {
            const error = mapResponseStatus(response.status, [response.statusText]);
            onDownloadFailure(error);
            return;
        }
        const fileName =
            response.headers
                .get('content-disposition')
                ?.split('filename=')[1]
                ?.replaceAll('"', '') || preparedDownloadFilename;
        const data = await response.blob();
        const blob = new Blob([data], { type: 'text/csv' });
        saveAs(blob, fileName);
        onDownloadSucceeded();
    } catch (error: unknown) {
        const typedError = error as Error;

        onDownloadFailure({
            _type: 'errors:ClientSideError',
            message: typedError?.message
        });
    }
}

type TDownloadDatasetArguments = {
    viewName: string;
    preparedDownloadFilename: string;
    onDownloadSucceeded: () => void;
    onDownloadFailure: (error: { _type: string; message?: string; code?: string }) => void;
};
export const downloadDataset = async ({
    viewName,
    preparedDownloadFilename,
    onDownloadSucceeded,
    onDownloadFailure
}: TDownloadDatasetArguments) =>
    await download({
        url: `/downloadDataset?targetName=${viewName}.csv&fileName=${preparedDownloadFilename}`,
        preparedDownloadFilename,
        onDownloadSucceeded,
        onDownloadFailure
    });
